<app-header-page>
    <h1>{{ 'HEADERS.BOARDS_CONNECTIONS' | translate }}</h1>
</app-header-page>

    <h1>{{ 'TASKS.SETTINGS.TEXT.BOARDS_LINKS' | translate }}</h1>
    <div class="btn-group"
         role="group">
        <button (click)="modalService.openTemplateModal(createLink)"
                *ngIf="!isDeleteMode"
                class="btn btn-primary btn-sm"
                data-action="createLink"
                style="margin-left: 10px;">
            <span>{{ 'TASKS.BUTTONS.CREATE_LINK' | translate }}</span>
        </button>
    </div>
        <app-graph-konva
                (emitEdgeEvent)="deleteEdge($event)"
                (emitNodeEvent)="handleNodeEvent($event)"
                [graphType]="'common'"
                [graphUISetting]="graphUISetting"
                [layoutDagreSettings]="layoutDagreSettings"
                [stageSettings]="stageSettings"
        >
        </app-graph-konva>

<ng-template #createLink let-modal>
    <app-button-modal-close (closeEmit)="clearModalData()"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body"
         style="padding-bottom: 45px;">
        <div class="super__tabs">
            <div [class.active]="true"
                 class="super__tabs tab">
                <span>{{ 'MODALS.HEADERS.LINKS_TAB.SELECT_BOARD' | translate }} <i
                        class="bi bi-chevron-right"></i></span>
            </div>
            <div [class.active]="step === 'selectStatus' || step === 'selectTargetBoard'"
                 class="super__tabs tab">
                <span>{{ 'MODALS.HEADERS.LINKS_TAB.SELECT_STATUS' | translate }} <i
                        class="bi bi-chevron-right"></i></span>
            </div>
            <div [class.active]="step === 'selectTargetBoard'"
                 class="super__tabs tab">
                <span>{{ 'MODALS.HEADERS.LINKS_TAB.SELECT_TO_BOARD' | translate }}</span>
            </div>
        </div>
        <div class="tab__content" style="margin-top: 10px;">
            <ng-container *ngIf="step === 'selectBoard'">
                <ng-container *ngTemplateOutlet="selectBoard">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="step === 'selectStatus'">
                <ng-container *ngTemplateOutlet="selectStatus">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="step === 'selectTargetBoard'">
                <ng-container *ngTemplateOutlet="selectTargetBoard">
                </ng-container>
            </ng-container>
        </div>

        <ng-template #selectBoard>
            <h1>{{ 'MODALS.HEADERS.SELECT_BP' | translate }}</h1>
            <span>{{ 'MODALS.TEXT.FROM_BP' | translate }}</span>

            <div class="modal_step">
                <div class="selected_element">
                    <h3>{{ 'MODALS.FIELDS.BUSINESS_PROCESS' | translate }}</h3>
                    <div *ngIf="outputDashboard"
                         class="view_element">
                        <div class="center">
                            <i [class]="outputDashboard.icon + ' icon'"></i>
                        </div>
                        <div class="center">
                            <strong> #{{ outputDashboard.alias }} {{ outputDashboard.name }}</strong>
                        </div>
                    </div>
                    <div *ngIf="!outputDashboard"
                         class="view_element">
                        <i>{{ 'MODALS.FIELDS.SELECT.NOT_SELECTED' | translate }}</i></div>
                </div>
                <div style="padding-top: 30px;">
                    <app-component-button-create-task (eminOnCreateDashboard)="refreshBoards($event)"
                                                      [isShowBoardButton]="true"
                                                      [isShowRightButtons]="false"
                                                      style="float: right; margin-bottom: 10px;"
                    ></app-component-button-create-task>

                    <select #outputTaskBoard (change)="selectModalBoard(outputTaskBoard.value, true)"
                            class="form-select"
                            style="margin-bottom: 10px">
                        <option [value]="null"
                                hidden>{{ 'MODALS.FIELDS.SELECT.BUSINESS_PROCESS' | translate }}
                        </option>
                        <option *ngFor="let board of taskOptionsService.boardsForOptions"
                                [value]="board.alias">
                            #{{ board.alias }} {{ board.name }}
                        </option>
                    </select>
                </div>
            </div>

            <button (click)="step = 'selectStatus'"
                    [disabled]="!outputDashboard"
                    class="btn btn-success"
                    data-action="nextButton"
                    style="position: absolute; right: 10px">{{ 'MODALS.BUTTONS.NEXT' | translate }}
            </button>
        </ng-template>

        <ng-template #selectStatus>
            <h1>{{ 'MODALS.HEADERS.SELECT_STATUS' | translate }}</h1>
            <span [innerHTML]=" 'MODALS.TEXT.FROM_STATUS' | translate:{alias: outputDashboard.alias, name: outputDashboard.name} "></span>

            <div class="modal_step"
                 style="justify-content: space-around;">
                <div class="selected_element">
                    <h3>{{ 'MODALS.FIELDS.STATUS' | translate }}</h3>
                    <div *ngIf="outputStatus"
                         style="padding: 10px">
                        <div [style]="'padding: 10px; background-color: ' + outputStatus.data.backgrCol"
                             class="view_element">
                            <i [class]="outputStatus.data.svg.class"
                               style="text-align: center; margin-right: 5px"></i>
                            <strong>{{ outputStatus.label }}</strong>
                        </div>
                    </div>
                    <div *ngIf="!outputStatus"
                         class="view_element">
                        <i>{{ 'MODALS.FIELDS.SELECT.NOT_SELECTED' | translate }}</i></div>
                </div>
                <div style="align-items: end">
                    <app-status-buttons (createDataEmit)="outputStatus = $event.status_node;"
                                        [creatingBoard]="outputDashboard"
                                        [graphGenerate]="false"
                                        [isOnlyCreateStatusButton]="true"
                                        style="float: right"
                    ></app-status-buttons>

                    <select #outputStatusNode (change)="selectOutputStatus(outputStatusNode.value)"
                            class="form-select"
                            style="margin-bottom: 10px">
                        <option [value]="null"
                                hidden>{{ 'MODALS.FIELDS.SELECT.STATUS' | translate }}
                        </option>
                        <option *ngFor="let node of outputDashboard.status_node_settings_of_member"
                                [value]="node.status_node.id">
                            {{ node.status_node.label }}
                        </option>
                    </select>
                </div>
            </div>

            <button (click)="step = 'selectTargetBoard'"
                    [disabled]="!outputStatus"
                    class="btn btn-success"
                    data-action="nextButton"
                    style="position: absolute; right: 10px">{{ 'MODALS.BUTTONS.NEXT' | translate }}
            </button>
            <button (click)="step = 'selectBoard'"
                    class="btn btn-success"
                    data-action="lastButton"
                    style="position: absolute; right: 100px">
                {{ 'MODALS.BUTTONS.BACK' | translate }}
            </button>
        </ng-template>

        <ng-template #selectTargetBoard>
            <h1>{{ 'MODALS.HEADERS.SELECT_TO_BOARD' | translate }}</h1>
            <span [innerHTML]="'MODALS.TEXT.TO_BOARD' | translate:{status: outputStatus.label, alias: outputDashboard.alias, name: outputDashboard.name}"></span>

            <div class="modal_step">
                <div class="selected_element">
                    <h3>{{ 'MODALS.FIELDS.BUSINESS_PROCESS' | translate }}</h3>
                    <div *ngIf="inputDashboard"
                         class="view_element">
                        <div class="center">
                            <i [class]="inputDashboard.icon + ' icon'"></i>
                        </div>
                        <div class="center">
                            <strong> #{{ inputDashboard.alias }} {{ inputDashboard.name }}</strong>
                        </div>
                    </div>
                    <div *ngIf="!inputDashboard"
                         class="view_element"><i>{{ 'MODALS.FIELDS.SELECT.NOT_SELECTED' | translate }}</i></div>
                </div>
                <div style="padding-top: 30px; ">
                    <app-component-button-create-task (eminOnCreateDashboard)="inputDashboard = $event"
                                                      [isShowBoardButton]="true"
                                                      [isShowRightButtons]="false"
                                                      style="float: right; margin-bottom: 10px;"
                    ></app-component-button-create-task>

                    <select #outputTaskBoard (change)="selectModalBoard(outputTaskBoard.value, false)"
                            class="form-select"
                            style="margin-bottom: 10px">
                        <option [value]="null"
                                hidden>{{ 'MODALS.FIELDS.SELECT.BUSINESS_PROCESS' | translate }}
                        </option>
                        <option *ngFor="let board of inputBoards"
                                [value]="board.alias">
                            #{{ board.alias }} {{ board.name }}
                        </option>
                    </select>
                </div>
            </div>

            <button (click)="createBoardsLink(modal)"
                    [disabled]="!inputDashboard || isLockButton"
                    class="btn btn-success"
                    data-action="createLinkButton"
                    style="position: absolute; right: 10px"
            ><span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span></button>
            <button (click)="step = 'selectStatus'"
                    class="btn btn-success"
                    data-action="lastButton"
                    style="position: absolute; right: 115px"
            >{{ 'MODALS.BUTTONS.BACK' | translate }}
            </button>
        </ng-template>
    </div>
</ng-template>

<ng-template #deleteStatusNode
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1 style="margin-bottom: 15px;">{{ 'MODALS.HEADERS.DELETE_STATUS' | translate }} {{ deleteStatus.label }}</h1>
        <small>{{ 'MODALS.TEXT.SELECT_TO_DELETE_STATUS' | translate }}</small>
        <div style="margin-bottom: 15px;">
            <div style="margin-bottom: 15px; margin-top: 10px;">
                <select [(ngModel)]="selectedStatus" class="form-select"
                        style="margin-bottom: 10px;">
                    <option [ngValue]="null"
                            hidden>{{ 'MODALS.FIELDS.SELECT.STATUS' | translate }}
                    </option>
                    <option *ngFor="let status of statusesOfDeletedBoard"
                            [ngValue]="status">{{ status.label }}
                    </option>
                </select>
            </div>
        </div>

        <strong>{{ 'MODALS.TEXT.CONFIRM_DELETE_STATUS' | translate }}</strong>
        <input #statusName
               class="form-control"
               required
               type="text">
        <button (click)="onDeleteStatus(statusName.value, modal)"
                [disabled]="isLockButton"
                class="btn btn-block btn-success"
                data-action="deleteLinkButton"
                style="margin-top: 15px">
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.DELETE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #settingsNodeView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1 style="margin-bottom: 15px;">{{ 'MODALS.HEADERS.STATUS_EDITOR' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}:
            <input #statusName
                   (change)="graphService.selectNode.label = statusName.value"
                   [value]="graphService.selectNode.label"
                   class="form-control"
                   type="text"
            >
        </h2>
        <div>
            <h2>{{ 'MODALS.FIELDS.ICON' | translate }}: </h2>
            <svg (click)="isShowIcons = !isShowIcons"
                 *ngIf="graphService.selectNode.data.svg.svg1"
                 class="{{graphService.selectNode.data.svg.class}}"
                 cursor="pointer"
                 fill="currentColor"
                 height="32"
                 viewBox="0 0 16 16"
                 width="32"
                 xmlns="http://www.w3.org/2000/svg">
                <path [attr.d]="graphService.selectNode.data.svg.svg1"/>
                <path [attr.d]='graphService.selectNode.data.svg.svg2'/>
            </svg>
            <i (click)="graphService.selectNode.data.svg = {}"
               *ngIf="graphService.selectNode.data.svg.svg1"
               class="bi bi-trash"
               style="color: red; cursor: pointer; margin-left: 10px;"></i>
            <i (click)="isShowIcons = !isShowIcons"
               *ngIf="!graphService.selectNode.data.svg.svg1"
               style="cursor: pointer;"
            >
                {{ 'MODALS.FIELDS.SELECT.ICON_NOT_SELECTED' | translate }}
            </i>
            <div *ngIf="isShowIcons"
                 class="iconsTable">
                <svg (click)="graphService.selectNode.data.svg = icon; isShowIcons = false"
                     *ngFor="let icon of graphService.svgIcons.allSvg"
                     class="{{icon.class}}"
                     cursor="pointer"
                     fill="currentColor"
                     height="32"
                     style="margin: 5px;"
                     viewBox="0 0 16 16"
                     width="32"
                     xmlns="http://www.w3.org/2000/svg">
                    <path [attr.d]="icon.svg1"/>
                    <path [attr.d]='icon.svg2'/>
                </svg>
            </div>
        </div>

        <h2 style="margin-top: 15px;">{{ 'MODALS.FIELDS.COLOR' | translate }}</h2>
        <app-color-picker
                (changeColor)="graphService.selectNode.data.backgrCol = $event"
                [color]="graphService.selectNode.data.backgrCol"
                [name]="graphService.selectNode.label"
        ></app-color-picker>

        <h2>{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h2>
        <textarea #description
                  (change)="graphService.selectNode.data.description = description.value"></textarea>

        <div *ngIf="!graphService.selectNode.data.is_archive">
            <div *ngIf="graphService.selectNode.data.is_universal && !graphService.selectNode.data.is_initial"
                 style="margin-top: 10px; margin-bottom: 10px">
                <input (change)="graphService.isUniversal = !graphService.isUniversal"
                       [checked]='graphService.isUniversal'
                       id="universal"
                       name="universal"
                       style="width: auto;"
                       title="{{ 'MODALS.FIELDS.UNIVERSAL_STATUS_TOOLTIP' | translate }}"
                       type="checkbox">
                <label for="universal"
                       style="margin-left: 5px;">{{ 'MODALS.FIELDS.UNIVERSAL_STATUS' | translate }}</label>
            </div>
            <span *ngIf="graphService.selectNode.data.is_universal !== graphService.isUniversal"
                  style="color: red">
                {{ 'MODALS.TEXT.SAVE_STATUS_CHANGES' | translate }}
            </span>

            <div *ngIf="!graphService.selectNode.data.is_universal && !graphService.selectNode.data.is_initial"
                 style="margin-top: 10px; margin-bottom: 10px">
                <input (change)="graphService.isSuccessful = !graphService.isSuccessful"
                       [checked]='graphService.isSuccessful'
                       id="end"
                       name="end"
                       style="width: auto;"
                       title="{{ 'MODALS.FIELDS.SUCCESSFUL_STATUS_TOOLTIP' | translate }}"
                       type="checkbox">
                <label for="end"
                       style="margin-left: 5px;">{{ 'MODALS.FIELDS.SUCCESSFUL_STATUS' | translate }}</label>
            </div>

            <div *ngIf="!graphService.selectNode.data.is_initial && !graphService.selectNode.data.is_archive && graphService.selectNode.data.is_finish"
                 style="margin-top: 10px; margin-bottom: 10px">
                <input (change)="graphService.toArchive = !graphService.toArchive"
                       [checked]='graphService.toArchive'
                       id="toArchive"
                       name="toArchive"
                       style="width: auto;"
                       title="{{ 'MODALS.FIELDS.TO_ARCHIVE_STATUS_TOOLTIP' | translate }}"
                       type="checkbox">
                <label for="toArchive"
                       style="margin-left: 5px;">{{ 'MODALS.FIELDS.TO_ARCHIVE_STATUS' | translate }}</label>
            </div>

            <div *ngIf="!graphService.selectNode.data.is_universal">
                <h2 style="margin-top: 15px;">{{ 'MODALS.TEXT.LINKS' | translate }}:</h2>
                <div style="margin-bottom: 15px;">
                    <h3>{{ 'MODALS.FIELDS.INCOMING_STATUSES' | translate }}</h3>
                    <div class="list-group">
                        <a *ngFor="let item of graphService.statuses.in"
                           class="list-group-item list-group-item-action">
                            {{ item.label }} <i (click)="graphService.fakeDeleteEdge(item, true)"
                                                class="bi bi-node-minus-fill"
                                                style="float: right; font-size: 20px"
                                                title="{{ 'MODALS.BUTTONS.DELETE' | translate }}"></i>
                        </a>
                        <i *ngIf="!graphService.statuses.in.length">{{ 'MODALS.FIELDS.SELECT.EMPTY' | translate }}</i>
                    </div>

                    <div style="margin-bottom: 15px; margin-top: 10px;">
                        <select (change)="graphService.addDependencies(false)" [(ngModel)]="graphService.selectedStatus"
                                class="form-select"
                                style="margin-bottom: 10px;">
                            <option [ngValue]="null"
                                    hidden>{{ 'MODALS.FIELDS.SELECT.ADD_STATUS' | translate }}
                            </option>
                            <option *ngFor="let status of graphService.statuses.availableIn"
                                    [ngValue]="status">{{ status.label }}
                            </option>
                        </select>
                    </div>

                    <h3 style="margin-top: 10px;">{{ 'MODALS.FIELDS.OUTCOMING_STATUSES' | translate }}</h3>
                    <div class="list-group">
                        <a *ngFor="let item of graphService.statuses.out"
                           class="list-group-item list-group-item-action">
                            {{ item.label }}  <i (click)="graphService.fakeDeleteEdge(item, false)"
                                                 class="bi bi-node-minus-fill"
                                                 style="float: right; font-size: 20px"
                                                 title="{{ 'MODALS.BUTTONS.DELETE' | translate }}"></i>
                        </a>
                        <i *ngIf="!graphService.statuses.out.length">{{ 'MODALS.FIELDS.SELECT.EMPTY' | translate }}</i>
                    </div>

                    <div style="margin-bottom: 15px; margin-top: 10px;">
                        <select (change)="graphService.addDependencies(true)" [(ngModel)]="graphService.selectedStatus"
                                class="form-select"
                                style="margin-bottom: 10px;">
                            <option [ngValue]="null"
                                    hidden>{{ 'MODALS.FIELDS.SELECT.ADD_STATUS' | translate }}
                            </option>
                            <option *ngFor="let status of graphService.statuses.availableOut"
                                    [ngValue]="status">{{ status.label }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <button (click)="saveNode(modal)"
                class="btn btn-block btn-success"
                data-action='saveStatusSettings'
                style="margin-top: 10px;">
            <span>{{ 'MODALS.BUTTONS.SAVE' | translate }}</span>
        </button>
    </div>
</ng-template>
